import { jsx as l } from "react/jsx-runtime";
import { c } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
const p = {
  // Elevated - Modern with subtle shadow, pure white background
  elevated: [
    "bg-card text-card-foreground",
    "shadow-sm border border-border-subtle"
  ].join(" "),
  // Outlined - Ultra-subtle border (almost invisible), clean look
  outlined: [
    "bg-transparent text-card-foreground",
    "border border-border"
  ].join(" "),
  // Glass - Glassmorphism effect with backdrop blur
  glass: [
    "bg-surface-glass/80 backdrop-blur-md text-card-foreground",
    "border border-border-subtle/50",
    "shadow-sm"
  ].join(" "),
  // Ghost - No background, no border (for composition)
  ghost: "bg-transparent text-card-foreground"
}, m = {
  none: "p-0",
  sm: "p-[calc(var(--density-padding)*0.75)]",
  md: "p-[var(--density-padding)]",
  lg: "p-[calc(var(--density-padding)*1.25)]",
  xl: "p-[calc(var(--density-padding)*1.5)]"
}, h = ({
  children: r,
  variant: e = "elevated",
  padding: a = "md",
  className: o,
  as: d,
  hoverable: t = !1,
  glowOnHover: s = !1,
  interactive: n = !1,
  ...i
}) => /* @__PURE__ */ l(
  d || "div",
  {
    className: c(
      // Base styles - Super-ellipse (2xl = 20px for continuous curve effect)
      "rounded-[var(--shape-radius-2xl)] overflow-hidden",
      // Smooth transitions for all interactive states
      "transition-all duration-normal ease-smooth",
      // Variant styles
      p[e],
      m[a],
      // Hover lift effect - modern card interaction
      t && [
        "hover:shadow-lift hover:-translate-y-0.5",
        "active:shadow-md active:translate-y-0"
      ],
      // Glow effect on hover (primary color glow)
      s && "hover:shadow-glow-primary",
      // Interactive cursor and scale effect
      n && [
        "cursor-pointer",
        "active:scale-press"
      ],
      o
    ),
    ...i,
    children: r
  }
);
export {
  h as C
};
